<template>
  <div class="control-index-page main-body">
    <div v-if="showSandboxSwitch">
      <ul class="select-item">
        <li v-for="(item,index) in dataList"
            :key="index" :data-index="index" :data-item="item.name"
            @click="switchEnv(item.number)"
            class="select-item" :class="{variation: sandbox === item.number,
            master: sandbox === 0 && sandbox === item.number}">{{ item.name }}
        </li>
      </ul>
    </div>
    <div class="page-title">我的应用</div>
    <div class="search-box search-box-samll">
      <el-form ref="searchForm" size="small"
               :model="searchObj"
               label-position="left"
               label-width="auto">
        <el-form-item label="应用名称" class="mr-lg">
          <el-input v-model="searchObj.app_name" maxlength="20" clearable placeholder="请输入应用名称"></el-input>
        </el-form-item>
        <el-form-item label="应用状态" class="mr-lg">
          <el-select class="width-full" v-model="searchObj.status" placeholder="请选择" clearable>
            <el-option v-for="item in $config.appStatusList" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间：" class="mr-lg width-auto">
          <el-date-picker
              v-model="searchObj.time_range"
              class="width-300"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <div class="inline-block v-top">
          <div class="search-btn sub-btn ml-lg " @click="funSearch">查询</div>
          <div class="search-btn sub-btn ml-lg" @click="funEditApp(0)">创建应用</div>
        </div>
      </el-form>
    </div>
    <div class="content-body">
      <div class="app-list-box">
        <div class="app-item" v-for="app in appList" :key="app.name">
          <div class="status-wrap">
            <div
                :class="['status-box', ['status-wait', 'status-reject', 'status-pass', 'status-stop'][app.status - 1]]">
              {{ $config.appStatusMap[app.status].label }}
            </div>
            <div class="type-box">No.{{ app.id }}</div>
          </div>
          <div class="app-info-box">
            <img :src="app.app_img_url" alt="" class="app-img" @click="funPreImg(app.app_img_url)">
            <div>
              <span
                  class="app-info-title text-ellipsis">{{
                  app.app_name.substr(0, Math.min(8, app.app_name.length))
                }} </span>
              <span v-if="app.app_name.length > 8" style="font-size: 4px">...</span>
              <span v-if="showSandboxSwitch && sandbox===0" class="env-box master layer" style="bottom: 3px">正式</span>
              <span v-if="showSandboxSwitch && sandbox===1" class="env-box sandbox layer" style="bottom: 3px">沙箱</span>
            </div>
            <div v-if="app.status !== 2">
              <div class="app-info-key">App_Key</div>
              <div class="app-info-value">{{ app.status === 3 || app.status === 4 ? app.app_key : '--' }}</div>
              <div class="app-info-key">App_Secret</div>
              <div class="app-info-value">{{ app.status === 3 || app.status === 4 ? app.app_secret : '--' }}</div>
            </div>
            <div class="app-reason-box" v-else>
              <div class="app-info-reason">{{ app.failure_reason }}</div>
            </div>
          </div>
          <div class="btn-box">
            <span class="text-info mr-btn" @click="goAppManage(app)"
                  v-if="app.status === 3 || app.status === 4">应用管理</span>
            <span class="text-info mr-btn" @click="goApiFlow(app)"
                  v-if="app.status === 3 || app.status === 4">查看API权限</span>
            <span class="text-info mr-btn" @click="funEditApp(1, app)" v-if="app.status === 2">重新提交审核</span>
            <span class="text-info" @click="appDelete(app)" v-if="app.status === 1 || app.status === 2">删除应用</span>
          </div>
        </div>
      </div>
      <div class="text-center" v-if="hasMore">
        <span class="load-more-btn" @click="loadMore">查看更多</span>
      </div>
      <div class="text-center" v-if="appList.length === 0">
        <span class="empty-box">暂无应用信息</span>
      </div>
    </div>

    <!--创建应用弹窗-->
    <el-dialog width="600px"
               :title="`${editInfo.action === 0 ? '创建应用' : '重新提交审核'}`"
               :close-on-click-modal="false"
               :visible.sync="editDialogShow" @close="closeEditDialog">
      <div class="select-content">
        <el-form ref="appForm"
                 class="form-content star-float"
                 :model="editInfo"
                 label-position="left"
                 label-width="90px">
          <el-form-item label="运行环境" class="mb-sm">
            <div v-if="showSandboxSwitch" style="display: inline-block">
              <span v-if="sandbox===0" class="env-box master">{{ curEnvStr }}</span>
              <span v-if="sandbox===1" class="env-box sandbox">{{ curEnvStr }}</span>
            </div>
            <div v-if="!showSandboxSwitch" style="display: inline-block">
              <span>{{ curEnvStrForPrd }}</span>
            </div>
            <i class="el-icon-info env-info-icon" @click="envInfoShow = true"></i>

          </el-form-item>
          <el-form-item label="应用名称" prop="app_name" :rules="rules.app_name">
            <el-input v-model="editInfo.app_name" maxlength="20" clearable placeholder="请输入应用名称"></el-input>
          </el-form-item>
          <el-form-item label="公司/个人" prop="company_name" :rules="rules.company_name">
            <el-input v-model="editInfo.company_name" maxlength="50" clearable placeholder="应用所属公司或个人名称"></el-input>
          </el-form-item>
          <el-form-item label="应用图标" prop="app_img_url" :rules="rules.app_img_url" class="is-required mb">
            <el-upload ref="uploadImg"
                       v-loading="uploadLoading1"
                       class="upload-box"
                       action="/ajax/common/interface/image/upload"
                       :headers="headerData"
                       :show-file-list="false"
                       name="image"
                       accept="image/jpg,image/jpeg,image/png"
                       :before-upload="beforeFileUpload"
                       :on-success="uploadSuccess"
                       :on-error="uploadError">
              <img v-if="editInfo.app_img_url" :src="editInfo.app_img_url" class="app-upload-img">
            </el-upload>
            <div class="upload-tips">图片支持格式为 JPEG、JPG、PNG<br/>图片大小不能超过2M</div>
          </el-form-item>
          <el-form-item label="申请资料" prop="company_data" :rules="rules.company_data" class="is-required">
            <el-upload ref="uploadZip"
                       v-loading="uploadLoading2"
                       class="upload-box"
                       action="/ajax/common/interface/file/upload"
                       :headers="headerData"
                       :show-file-list="false"
                       name="file"
                       accept=".zip,.rar"
                       :before-upload="beforeZipUpload"
                       :on-success="uploadZipSuccess"
                       :on-error="uploadZipError">
              <img v-if="editInfo.company_data" src="../../assets/img/control/zip.png" class="app-upload-img">
            </el-upload>
            <div class="upload-tips">
              <span>文件支持格式为 rar、zip<br/>文件大小不超过20M<br/></span>
              <a class="text-info inline-block mt-xxl" :href="templateUrl" download="申请资料示例模板">下载示例模板</a>
            </div>
          </el-form-item>
          <el-button class="edit-submit-btn mt-sm" @click="appSubmit">提交</el-button>
        </el-form>
      </div>
    </el-dialog>
    <!--环境信息弹窗-->
    <el-dialog width="400px"
               title="提示"
               class="small-el-dialog"
               :close-on-click-modal="false"
               :visible.sync="envInfoShow" @close="envInfoShow = false">
      <div v-if="showSandboxSwitch" class="select-content">
        {{ `当前为${curEnvStr}，如需创建${againstEnvStr}应用，请切换到` }}
        <span class="text-warning"
        >{{ `${againstEnvStr}` }}</span> 进行相关操作。
      </div>
      <div v-if="!showSandboxSwitch" class="select-content">
        {{ `当前为${curEnvStrForPrd}，如需创建${againstEnvStrForPrd}应用，请到开放平台` }}
        <span class="text-warning"
              @click="envJump">{{ `${againstEnvStrForPrd}（https://open${againstEnvTag}.huolala.cn）` }}</span>进行相关操作。
      </div>
    </el-dialog>
    <!--图片预览弹窗-->
    <img-preview v-model="imgPreview.show" :data="imgPreview.data"></img-preview>
  </div>
</template>

<script>
import ImgPreview from '../common/hll-img-preview'
import {formatDate} from '../../assets/js/common'
import {sandboxRequest} from "../../axios/sandboxRequest";

export default {
  name: 'controlIndex',

  data() {
    let nameCheck = (rule, value, callback) => {
      if (value.indexOf('【') !== -1 || value.indexOf('】') !== -1) {
        callback(new Error('应用名称中不能包含特殊符号"【"和"】"'));
      } else {
        callback();
      }
    }
    return {
      showSandboxSwitch: false,
      shadowColor: '#4A90E27A',
      dataList: [{name: '沙箱', number: 1}, {name: '正式', number: 0}],
      headerData: {
        Authorization: localStorage.getItem('token')
      },
      searchObj: {
        app_name: null,
        status: null, // 1：待审核 2：审核未通过；3:上线运行
        time_range: '',
      },
      appList: [],
      pageIndex: 1,
      hasMore: false,
      editDialogShow: false,
      envInfoShow: false,
      templateUrl: '',
      editInfo: {
        action: 0, // 0-新增 1-重新提交审核
        app_id: '', // 应用ID
        app_name: '', // 应用名称
        app_img_url: '', // 应用图标
        company_name: '', // 申请公司名称
        company_data: '', // 申请资料
        company_file: '', // 申请资料文件名 - 用于展示
        call_back: '', // 回调地址
      },
      imgPreview: {
        show: false,
        data: ''
      },
      uploadLoading1: false,
      uploadLoading2: false,
      rules: {
        company_name: [
          {required: true, message: '请输入公司名称', trigger: 'blur'}
        ],
        app_name: [
          {required: true, message: '请输入应用名称', trigger: 'blur'},
          {validator: nameCheck, trigger: 'blur'}
        ],
        app_img_url: [
          {required: true, message: '请上传应用图标', trigger: 'blur'}
        ],
        company_data: [
          {required: true, message: '请上传申请资料', trigger: 'blur'}
        ],
        call_back: [
          {required: true, message: '请输入应用的回调地址', trigger: 'blur'}
        ],
      }
    }
  },
  computed: {
    isPrd() {
      return location.hostname.indexOf('open.huolala.cn') !== -1;
    },
    curEnvStrForPrd() {
      return this.isPrd ? '生产环境' : '测试环境';
    },

    againstEnvStrForPrd() {
      return this.isPrd ? '测试环境' : '生产环境';
    },


    curEnvStr() {
      return this.sandbox === 1 ? '沙箱环境' : '正式环境';
    },
    againstEnvStr() {
      return this.sandbox === 0 ? '沙箱环境' : '正式环境';
    },
    againstEnvTag() {
      return this.isPrd ? '-pre' : '';
    },
  },
  components: {
    ImgPreview
  },
  mounted() {
    this.envIsOpen();
    this.getTemplate(); // 获取申请资料模板链接
    this.funSearch();
  },
  watch: {
    '$route.query'(newVal, oldVal) { // 浏览器地址变化
      this.sandbox = Number(newVal.sandbox);
    },
    sandbox: { // sandbox值变化时
      handler(newValue, oldValue) {
        if (newValue === undefined || newValue === oldValue) {
          return;
        }
        this.sandboxChanged(newValue);
      },
    },
  },
  methods: {
    /**-----------------------沙箱环境切换及同步相关-----------------------*/
    envIsOpen() { // 沙箱环境是否开启
      sandboxRequest.showSandboxEnv().then(res => {
        this.showSandboxSwitch = res.ret === 0 && res.data;
      })
    },
    switchEnv(number) { // 用户按钮操作环境
      if (this.sandbox === number) {
        return;
      }
      this.sandbox = number;
      // 浏览器地址参数同步，否则刷新将无法生效
      let query = this.$route.query;
      if (Number(query.sandbox) !== this.sandbox) {
        this.$router.replace({
          path: `/control/myapp?sandbox=${this.sandbox}`
        })
      }
    },

    // 观察者模式：sandbox改变，必须经过这个方法
    sandboxChanged(sandbox) {
      this.sandbox = sandbox;
      this.envChanged();
    },

    // UI: 环境切换完成后的UI变更，不涉及环境值
    envChanged() {
      if (this.sandbox === 1 && !this.hasBound) { // 未绑定沙箱账号，跳转到沙箱账号
        this.$router.push({path: '/bind', showSwitch: true});
      } else {
        this.funSearch();
      }
    },
    /**------------------沙箱环境切换及同步相关结束-----------------------*/

    /**----------------------router相关开始----------------------------*/
    goAppManage(app) {
      this.push('/control/app/info/' + app.id);
    },
    goApiFlow(app) {
      this.push('/control/app/flow/' + app.id);
    },
    push(path) {
      this.$router.push({path: path, query: {sandbox: this.sandbox.toString()}});
    },
    // 环境跳转
    envJump() {
      window.open(`https://open${this.againstEnvTag}.huolala.cn`);
    },
    /**------------------router结束-----------------------*/

    /**------------------页面按钮操作-----------------------*/
    funSearch() {
      this.pageIndex = 1;
      this.getAppList();
    },
    // 查看更多
    loadMore() {
      this.pageIndex++;
      this.getAppList();
    },
    // 图片预览
    funPreImg(img) {
      this.imgPreview.data = img;
      this.imgPreview.show = true;
    },

    // action 0-新增 1-重新提交审核
    funEditApp(action, app) {
      this.editInfo.action = action;
      if (action === 1) {
        this.editInfo.app_id = app.id;
        this.editInfo.app_name = app.app_name;
        this.editInfo.app_img_url = app.app_img_url;
        this.editInfo.company_name = app.company_name;
        this.editInfo.company_data = '';
        this.editInfo.company_file = '';
        this.editInfo.call_back = app.call_back;
      }
      this.editDialogShow = true;
    },
    // 取消编辑
    closeEditDialog() {
      this.editInfo.action = 0;
      this.editInfo.app_id = '';
      this.editInfo.app_name = '';
      this.editInfo.app_img_url = '';
      this.editInfo.company_name = '';
      this.editInfo.company_data = '';
      this.editInfo.company_file = '';
      this.editInfo.call_back = '';
      this.editDialogShow = false;
      this.$nextTick(() => {
        if (this.$refs.appForm) {
          this.$refs.appForm.clearValidate(); // 重置时会触发校验 移除
        }
      })
    },

    /**网络请求开始*/
    // 获取应用列表
    getAppList() {
      if (this.isLoading) {
        return
      }
      this.showCommonLoading();
      let start_date = null;
      let end_date = null;
      if (this.searchObj.time_range && this.searchObj.time_range.length) {
        start_date = formatDate(this.searchObj.time_range[0], 'yyyy-MM-dd') + ' 00:00:00';
        end_date = formatDate(this.searchObj.time_range[1], 'yyyy-MM-dd') + ' 23:59:59';
      }
      this.server.post("/ajax/control/panel/app/list", {
        ...this.searchObj,
        start_date: start_date,
        end_date: end_date,
        page_no: this.pageIndex,
        page_size: 9
      }).then(res => {
        this.hideCommonLoading();
        if (this.pageIndex === 1) {
          this.appList = res.data.data.list;
        } else {
          this.appList = this.appList.concat(res.data.data.list);
        }
        this.hasMore = res.data.data.total > this.appList.length;
      }).catch(e => {
        this.hideCommonLoading();
      });
    },

    // 提交
    appSubmit() {
      if (this.isLoading) {
        return;
      }
      this.$refs.appForm.validate(valid => {
        if (valid) {
          let url = '';
          let action = '';
          if (this.editInfo.action === 0) {
            url = '/ajax/control/panel/app/add';
            action = '创建';
          } else {
            url = '/ajax/control/panel/app/renew';
            action = '重新提交审核';
          }
          this.showCommonLoading();
          this.server.post(url, this.editInfo).then(res => {
            this.hideCommonLoading();
            if (res.data.ret === 0) {
              this.closeEditDialog();
              this.$message.success(`${action}成功`);
              this.funSearch();
            }
          }).catch(e => {
            this.hideCommonLoading();
          });
        }
      })
    },
    // 删除应用
    appDelete(app) {
      if (this.isLoading) {
        return
      }
      this.$confirm('确定删除该应用吗？', '', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning',
        showClose: false,
      }).then(() => {
        this.showCommonLoading();
        this.server.post("/ajax/control/panel/app/delete", {
          app_id: app.id
        }).then(res => {
          this.hideCommonLoading();
          if (res.data.ret === 0) {
            this.$message.success('删除成功');
            this.funSearch();
          }
        }).catch(e => {
          this.hideCommonLoading();
        });
      }).catch(() => {
      });
    },
    /**--------------------------网络请求结束-----------------------------------*/

    /**--------------------------文件上传相关----------------------------------*/
    beforeFileUpload(file) {
      let isValid = true;
      let strArr = file.name.split('.');
      let type = strArr[strArr.length - 1].toLowerCase();
      if (file.size / 1024 / 1024 > 2) {
        isValid = false;
        this.$message.error('图片不能大于2M');
      }
      if (['jpeg', 'jpg', 'png'].indexOf(type) === -1) {
        isValid = false;
        this.$message.error('图片格式仅支持 JPEG、JPG、PNG');
      }
      isValid && (this.uploadLoading1 = true);
      return isValid;
    },
    uploadSuccess(res, file) {
      this.uploadLoading1 = false;
      if (res.ret === 0) {
        this.editInfo.app_img_url = res.data;
        this.$refs.appForm.validateField('app_img_url');
      } else {
        this.$refs.uploadImg.clearFiles();
      }
    },
    uploadError(res, file) {
      this.uploadLoading1 = false;
      this.$message.error('上传图片失败');
    },
    beforeZipUpload(file) {
      let isValid = true;
      let strArr = file.name.split('.');
      let type = strArr[strArr.length - 1].toLowerCase();
      if (file.size / 1024 / 1024 > 20) {
        isValid = false;
        this.$message.error('申请资料不能大于20M');
      }
      if (['zip', 'rar'].indexOf(type) === -1) {
        isValid = false;
        this.$message.error('文件格式仅支持 rar、zip');
      }
      isValid && (this.uploadLoading2 = true);
      return isValid;
    },
    uploadZipSuccess(res, file) {
      this.uploadLoading2 = false;
      if (res.ret === 0) {
        this.editInfo.company_data = res.data;
        this.editInfo.company_file = file.name || 'zip';
        this.$refs.appForm.validateField('company_data');
      } else {
        this.$refs.uploadZip.clearFiles();
      }
    },
    uploadZipError(res, file) {
      this.uploadLoading2 = false;
      this.$message.error('上传申请资料失败');
    },
    // 下载示例模板
    getTemplate() {
      this.server.get('/ajax/control/panel/app/sample').then(res => {
        this.templateUrl = res.data.data.url;
      }).catch(e => {
      });
    },
  }
}
</script>

<style lang="scss">
.control-index-page {
  .el-dialog__body {
    overflow: hidden;
  }

  .select-content {
    margin-right: -1px;
    margin-left: -1px;

    .el-table th {
      background: #717384;
      color: #fff;
    }

    .el-table tr {
      height: 60px;
    }
  }

  .upload-box {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: middle;

    .el-upload {
      width: 80px;
      height: 80px;
      background: url("../../assets/img/control/icon_upload.png");
      background-size: 100% 100%;
    }

    .app-upload-img {
      width: 100%;
      height: 100%;
      vertical-align: top;
      background: #fff;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
    }

    .zip-upload-text {
      max-width: 60px;
      max-height: 60px;
      box-sizing: border-box;
      line-height: 20px;
      color: #aaa;
      margin: 0 auto;
      overflow: hidden;
    }
  }

  .upload-tips {
    display: inline-block;
    margin-left: 7px;
    color: #9E9E9E;
    font-size: 12px;
    line-height: 16px;
    position: relative;
    top: 30px;
  }

  .select-content {
    .el-form-item__error {
      width: 150px;
      /*height: 40px;*/
      word-break: break-all;
    }
  }

  .small-el-dialog {
    .el-dialog__header {
      height: 36px;
      line-height: 40px;
      text-align: left;
      font-size: 16px;
      padding-left: 20px;
    }

    .el-dialog__headerbtn {
      top: 11px;
    }

    .el-dialog__body {
      padding: 20px;
    }
  }
}
</style>
<style lang="scss" scoped>
.control-index-page {
  width: 1170px;
  padding: 0 0 30px;
  margin: 0 auto;

  .page-title {
    width: 100%;
    height: 34px;
    line-height: 32px;
    font-size: 24px;
    color: #212121;
    text-align: center;
    margin: 24px 0;
  }


  .content-body {
    margin-top: 34px;
    background: #F4F5F6;
    padding: 20px 25px;
  }

  .app-list-box {
    width: 100%;
  }

  .load-more-btn {
    display: inline-block;
    height: 22px;
    line-height: 22px;
    color: #9E9E9E;
    font-size: 16px;
    cursor: pointer;
  }

  .empty-box {
    display: inline-block;
    height: 60px;
    line-height: 60px;
    color: #9E9E9E;
    font-size: 16px;
  }
}

.app-item {
  display: inline-block;
  width: 350px;
  height: 263px;
  margin: 0 34px 37px 0;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  background: #fff;
  border-radius: 2px;
  position: relative;
  vertical-align: top;

  &:nth-child(3n) {
    margin-right: 0;
  }

  .status-wrap {
    width: 100%;
    height: 44px;
    padding-top: 4px;

    .status-box {
      float: left;
      width: 94px;
      height: 35px;
      line-height: 31px;
      margin-left: -4px;
      color: #fff;
      text-align: center;
    }

    .status-pass {
      background: url("../../assets/img/control/check_pass.png");
      background-size: 100% 100%;
    }

    .status-wait {
      background: url("../../assets/img/control/check_wait.png");
      background-size: 100% 100%;
    }

    .status-reject {
      background: url("../../assets/img/control/check_reject.png");
      background-size: 100% 100%;
    }

    .status-stop {
      background: url("../../assets/img/control/check_stop.png");
      background-size: 100% 100%;
    }

    .type-box {
      float: right;
      width: auto;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
      padding: 0 4px;
      margin: 9px 15px 0 20px;
      background: rgba(170, 167, 166, 0.1);
      color: #9E9E9E;
    }
  }

  .app-info-box {
    width: 100%;
    padding: 0 20px 0 120px;
    position: relative;
    box-sizing: border-box;

    .app-img {
      position: absolute;
      left: 19px;
      top: 10px;
      width: 80px;
      height: 80px;
      cursor: pointer;
    }

    .app-info-title {
      font-size: 18px;
      color: #424456;
    }

    .app-info-key {
      font-size: 12px;
      line-height: 12px;
      color: #9E9E9E;
      margin-top: 6px;

      &:first-child {
        margin-top: 14px;
      }
    }

    .app-info-value {
      width: 100%;
      height: 32px;
      font-size: 12px;
      line-height: 16px;
      color: #424456;
      margin-top: 6px;
      word-break: break-all;
    }
  }

  .app-reason-box {
    width: 210px;
    height: 102px;
    color: #9E9E9E;
    font-size: 12px;
    line-height: 17px;
    margin-top: 11px;
    overflow: hidden;

    &:before {
      content: '';
      float: left;
      width: 5px;
      height: 100%;
    }

    .app-info-reason {
      float: right;
      width: 100%;
      margin-left: -5px;
      word-break: break-all;
    }

    &:after {
      content: '...';
      box-sizing: content-box;
      float: right;
      position: relative;
      width: 30px;
      height: 17px;
      margin-top: -17px;
      left: 100%;
      margin-left: -30px;
      text-align: left;
      padding-left: 5px;
      background: #fff;
    }
  }

  .btn-box {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 48px;
    line-height: 48px;
    padding: 0 20px;
    color: #424456;
    border-top: 1px solid rgba(224, 224, 224, 0.5);
    box-sizing: border-box;

    .mr-btn {
      margin-right: 35px;
    }
  }
}

.select-btn-box {
  padding: 30px 35px;
  text-align: right;
}

.form-content {
  width: 460px;
  margin: 0 75px 0 65px;
  padding: 24px 0 30px;

  .edit-submit-btn {
    width: 370px;
    background: #F16622;
    color: #fff;
    margin-left: 90px;
    border: none;
  }
}

.env-info-icon {
  font-size: 16px;
  color: #999;
  position: relative;
  top: 1px;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/control/index.vue